import styled from 'styled-components'

export const Card = styled.div`
  display: flex;
  flex-direction: column;

  padding: 2em;
  background-color: ${({ theme }) => theme.colors.surface.on};
  box-shadow: 1px 1px 8px ${({ theme }) => theme.colors.surface.border};
  border-radius: 3px;
`

export const Divider = styled.div`
  height: 2px;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.surface.border};
`
